import { Ng1StateDeclaration } from '@uirouter/angularjs';

const states: Ng1StateDeclaration[] = [{
    name: 'tagsImport',
    url: '/TagsImport/:connectionPointGuid',
    component: 'wtTagsImportState',
    params: {
        connectionPointGuid: ''
    },
    data: {
        visible: false,
        sortingOrder: 20,
        displayName: 'Import tags',
        editButtonVisibility: () => true,
        editButtonDisabled: () => true,
        canEdit: false
    }
}];

export default states;